import ServiceBase from './ServiceBase';
import { ZipCode } from '@/models/zipCodes/ZipCode';
import { ZipCodeSearchOptions } from '@/models/zipCodes/ZipCodeSearchOptions';
import { CoordinateResult } from '@/models/zipCodes/CoordinateResult';
import OperationStatusResponse from '@/models/misc/OperationStatusResponse';

class ZipCodesService extends ServiceBase {

    async searchWithPaging(
        options: ZipCodeSearchOptions,
        page: number,
        pageSize: number
    ): Promise<{ data: ZipCode[]; totalCount: number }> {
        const requestBody = {
            searchTerm: options.searchTerm || '',
            zipCode: options.zipCode || '',
            city: options.city || '',
            state: options.state || '',
            country: options.country || '',
            page: page,
            pageSize: pageSize
        };

        const response = await this.postWithRawResult<any>('/api/zipcodes/search/paged', requestBody, null);

        return {
            data: response?.data ? response.data.map((item: any) => new ZipCode(item)) : [],
            totalCount: response?.totalCount || 0,
        };
    }

    async create(zipCode: ZipCode): Promise<ZipCode> {
        const data = await this.post<ZipCode>('/api/zipcodes', zipCode, null);
        return new ZipCode(data);
    }

    async update(zipCode: ZipCode): Promise<ZipCode> {
        const data = await this.put<ZipCode>(`/api/zipcodes`, zipCode, null);
        return new ZipCode(data);
    }

    async deleteZipCode(zipCode: string, city: string): Promise<OperationStatusResponse> {
        const response = await this.delete(`/api/zipcodes?zipCode=${encodeURIComponent(zipCode)}&city=${encodeURIComponent(city)}`);
        return response;
    }

    async getCoordinates(address: string): Promise<CoordinateResult | null> {
        // For now, return placeholder coordinates
        // In a real implementation, this would call a geocoding API like Google Maps, MapBox, etc.

        // Simulate API call delay
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Return mock coordinates (example: coordinates for New York City)
        return {
            latitude: 40.7128,
            longitude: -74.0060
        };
    }

}

export default new ZipCodesService(); 